import api from '@pray/shared/utils/api';

export async function triggerLocalizedTranscription({ artistId, contentId, locale }) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentId) throw Error('Content ID is required');
  if (!locale) throw Error('Locale is required');

  const url = `/web/studio/artists/${artistId}/content/${contentId}/locales/${locale}/transcription`;
  const response = await api.executePostRequest(url);

  return response.data;
}
